import React from "react";
import ProfileInput from "./ProfileInput";
import { useReduxStore } from "../hooks/useReduxStore";
import { ChangePasswordAction } from "../store/Actions/action";
import Schemas from "../utilities/validations";
import { useForm } from "react-hook-form";
export default function ChangePasswordComponent({ dark = false }) {
  const { dispatch } = useReduxStore();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: Schemas.changePassword,
  });

  const onSave = (data = {}) => {
    let { new_password, old_password, password_confirmation } = data;
    dispatch(
      ChangePasswordAction({
        current_password: old_password,
        password: new_password,
        password_confirmation,
      })
    );
  };
  return (
    <div className="flex flex-col gap-6">
      <ProfileInput
        label={"Current Password"}
        placeholder="Enter Current Password"
        type="password"
        id="c_password"
        name={"old_password"}
        register={register}
        errors={errors}
        dark={dark}
      />
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <ProfileInput
          label={"New Password"}
          placeholder="Enter New Password"
          type="password"
          id="n_password"
          name={"new_password"}
          register={register}
          errors={errors}
          dark={dark}
        />
        <ProfileInput
          label={"Confirm Password"}
          placeholder="Enter New Password Again"
          type="password"
          id="n_password_a"
          name={"password_confirmation"}
          register={register}
          errors={errors}
          dark={dark}
        />
      </div>
      <div className="mt-4">
        <button
          onClick={handleSubmit(onSave)}
          className="inline-block w-full rounded-md bg-secondary hover:bg-orange-600 px-8 py-3 font-semibold text-white sm:w-auto transition-colors duration-200 shadow-md hover:shadow-lg focus:outline-none"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}
